import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
// import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { postsStore } from "../../../../stores/posts/postsStore";
import { textFieldStyle } from "../../../../assets/styles/styles";
import { AdminPostCard } from "./AdminPostCard";
import { Box } from "@mui/material";
import { makeStyles } from "@material-ui/core";
export const AdminSearchPostComboBox = ({ sx = {}, ...props }) => {
    const items = postsStore.usePosts();
    const [item, setItem] = useState(null);
    const useStyles = makeStyles({
        root: {
            width: 300,
            ...textFieldStyle,
            ...sx,
        },
    });
    const classes = useStyles();
    useEffect(() => {
        if (item && !items.find(i => i.id === item.id))
            setItem(null);
    }, [items.length, item]);
    return (_jsxs(_Fragment, { children: [_jsx(Autocomplete, { id: "post-search-combobox", options: items, getOptionLabel: (i) => `${i.title} ${i.description}`, onChange: (_event, newValue) => setItem(newValue), value: item, className: classes.root, renderInput: (params) => _jsx(TextField, { ...params, label: "search a post", variant: "outlined" }, void 0), renderOption: (i) => (_jsx(Box, { component: "li", children: _jsxs(Box, { children: [_jsx(Box, { children: i.title }, void 0), _jsx(Box, { sx: { fontSize: '0.85rem', opacity: 0.9, whiteSpace: "pre-wrap" }, children: i.description }, void 0)] }, void 0) }, void 0)), ...props }, void 0), item
                ?
                    _jsx("div", { style: { padding: 10 }, children: _jsx(AdminPostCard, { post: item }, void 0) }, void 0)
                : null] }, void 0));
};
//# sourceMappingURL=AdminSearchPostComboBox.js.map